import axios from "axios";
export default {
  upload(data) {
    return axios({
      url: "/oss",
      method: "post",
      data: data,
    })
      .then((res) => res)
      .catch((err) => err);
  },
  upload2(data) {
    return axios({
      url: "/oss/sts",
      method: "post",
      data: data,
    })
      .then((res) => res)
      .catch((err) => err);
  },
  upVideo(data) {
    return axios({
      url: "/video",
      method: "post",
      data: data,
    })
      .then((res) => res)
      .catch((err) => err);
  },
  getUserVideo(params) {
    return axios({
      url: "/video",
      method: "get",
      params,
    })
      .then((res) => res)
      .catch((err) => err);
  },
  getVideoList(params) {
    return axios({
      url: "/video/pages",
      method: "get",
      params,
    })
      .then((res) => res)
      .catch((err) => err);
  },
  getVideoInfo(id) {
    return axios({
      url: "/video/" + id,
      method: "get",
    })
      .then((res) => res)
      .catch((err) => err);
  },
  getOneVideo(id) {
    return axios({
      url: "/video/getOneVideo/" + id,
      method: "get",
    })
      .then((res) => res)
      .catch((err) => err);
  },
  editVideo(data) {
    return axios({
      url: "/video/" + data.id,
      method: "post",
      data,
    })
      .then((res) => res)
      .catch((err) => err);
  },
  delVideo(data) {
    return axios({
      url: "videomgr/-",
      method: "post",
      data,
    })
      .then((res) => res)
      .catch((err) => err);
  },
  playVideo(fileId) {
    return axios({
      url: "/fs/v/" + fileId,
      method: "get",
    })
      .then((res) => res)
      .catch((err) => err);
  },
};
